import { createFileRoute } from '@tanstack/react-router';
import { FirefliesCallbackPage } from '@/containers/integrations/google-callback-page.component';

export const Route = createFileRoute('/integrations/fireflies/callback')({
  component: FirefliesCallbackPage,
});
